import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import AdminPage from "./pages/AdminPage";
import {
  MentionsLegales,
  PolitiqueConfidentialite,
  PolitiqueCookies,
  CGV,
} from "./pages/LegalPages";
import LeadDialog from "./components/LeadDialog";
import CookieBanner from "./components/CookieBanner";
import { Toaster } from "./components/ui/sonner";

function App() {
  const [dialog, setDialog] = useState({
    open: false,
    mode: "recruit",
    job: null,
  });

  const openRecruit = () =>
    setDialog({ open: true, mode: "recruit", job: null });
  const openCandidate = () =>
    setDialog({ open: true, mode: "candidate", job: null });
  const openApply = (job) => setDialog({ open: true, mode: "candidate", job });

  useEffect(() => {
    document.title =
      "Looking4 | Recrutement Industrie - Bretagne et Pays de la Loire";
  }, []);

  return (
    <div className="App min-h-screen bg-[#0a1626] antialiased">
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <Home
                onRecruit={openRecruit}
                onCandidater={openCandidate}
                onApply={openApply}
              />
            }
          />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route
            path="/politique-confidentialite"
            element={<PolitiqueConfidentialite />}
          />
          <Route path="/politique-cookies" element={<PolitiqueCookies />} />
          <Route path="/cgv" element={<CGV />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>

        <LeadDialog
          open={dialog.open}
          onOpenChange={(o) => setDialog((d) => ({ ...d, open: o }))}
          mode={dialog.mode}
          job={dialog.job}
        />
        <CookieBanner />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
